export const mustVisitArray = [
  {
    title: "acropolis",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/must-visit/acropolis.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Acropolis/@37.9666828,23.7245785,15z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd115926d4b3:0xc1b7afae2bd1b7ea!8m2!3d37.9666667!4d23.7333333?hl=en&authuser=0",
  },
  {
    title: "acropolisMuseum",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/must-visit/acropolis-museum.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Acropolis+Museum/@37.9684541,23.726334,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd173f46e4e1:0xb00fb46a2c010a3c!8m2!3d37.9684499!4d23.7285227?hl=en&authuser=0",
  },
  {
    title: "nationalArchaeologicalMuseum",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/must-visit/national-archaeological.jpg`,
    mapLink:
      "https://www.google.com/maps/place/National+Archaeological+Museum/@37.9890271,23.7305712,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd33bfc5fd8b:0x2a29d34aacb82b4!8m2!3d37.9890229!4d23.7327599?hl=en&authuser=0",
  },
  {
    title: "parthenon",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/must-visit/parthenon.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Parthenon/@37.9715327,23.7245279,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd19ca39ee61:0x1b3fa079b878a218!8m2!3d37.9715285!4d23.7267166?hl=en&authuser=0",
  },
  {
    title: "plaka",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/must-visit/plaka.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Plaka,+Athens,+Greece/@37.9720594,23.7247579,16z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd170bda3a31:0x50a33e9d3910ddb1!8m2!3d37.9725529!4d23.7303364?hl=en&authuser=0",
  },
];

export const accommodationArray = [
  {
    title: "hotel",
    details: ["accommodationDetails1", "accommodationDetails2"],
    image: `${process.env.PUBLIC_URL}/assets/images/tips/accommodation/ag-k-eunirCQ_WXk-unsplash.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Lemon+Tree+Suites+Near+the+Airport/@37.8830849,23.9274574,17z/data=!4m8!3m7!1s0x14a1913ffae6dc27:0x20743a525b99ba62!5m2!4m1!1i2!8m2!3d37.8831308!4d23.9275634",
  },
];

export const transportationArray = [
  {
    title: "transportation",
    details: [
      "transportationDetails1",
      "transportationDetails2",
      "transportationDetails3",
    ],
    image: `${process.env.PUBLIC_URL}/assets/images/tips/accommodation/ag-k-eunirCQ_WXk-unsplash.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Lemon+Tree+Suites+Near+the+Airport/@37.8830849,23.9274574,17z/data=!4m8!3m7!1s0x14a1913ffae6dc27:0x20743a525b99ba62!5m2!4m1!1i2!8m2!3d37.8831308!4d23.9275634",
  },
];

export const restaurantsArray = [
  {
    title: "Baltazar",
    foodStyles: ["mediterranean", "european", "sushi"],
    rating: "4.3",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/restaurants/baltazar.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Balthazar/@37.9858351,23.7540189,17z/data=!4m5!3m4!1s0x14a1bd536f8f0d63:0x2caf46d7f71df5ca!8m2!3d37.9858309!4d23.7562076?hl=en&authuser=0",
  },
  {
    title: "Caravin Wine & Wanderlust",
    foodStyles: ["mediterranean", "diner", "wineBar"],
    rating: "4.7",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/restaurants/caravin-wine-bar.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Caravin+wine+%26+wanderlust/@37.9744228,23.7146713,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd0cbec98805:0xba6e79e5209cec43!8m2!3d37.9744186!4d23.7188985?hl=en&authuser=0",
  },
  {
    title: "Cinque Wine & Deli Bar",
    foodStyles: ["greek", "deli", "wineBar"],
    rating: "4.8",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/restaurants/cinque-wine-deli-bar.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Cinque+Wine+%26+Deli+Bar/@37.9783986,23.7212113,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd23be2269d5:0x4335a600d757884!8m2!3d37.9783857!4d23.723419?hl=en&authuser=0",
  },
  {
    title: "Indian Palace",
    foodStyles: ["indian", "asian", "vegetarianFriendly"],
    rating: "4.9",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/restaurants/indian-palace.jpg`,
    mapLink:
      "https://www.google.com/maps/place/Indian+Palace+Restaurant/@37.97788,23.7539762,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd3e146c86e1:0x30b2ef57ab1e3483!8m2!3d37.9778775!4d23.7561626?hl=en&authuser=0",
  },
  {
    title: "Oroscopo",
    foodStyles: ["italian", "mediterranean", "greek"],
    rating: "4.7",
    image: `${process.env.PUBLIC_URL}/assets/images/tips/restaurants/oroscopo.jpg`,
    mapLink:
      "https://www.google.com/maps/place/OROSCOPO+restaurant/@37.9734264,23.7483554,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1bd435a3a3833:0x68dbe9ba33174a8a!8m2!3d37.9734222!4d23.7505441?hl=en&authuser=0",
  },
];
